const PanelIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <rect x="1.5" y="2.5" width="13" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.3" />
    <line x1="6.2" y1="2.5" x2="6.2" y2="13.5" stroke="currentColor" strokeWidth="1.3" />
  </svg>
);

export default PanelIcon;
